import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useRef, useState } from 'react'
import Tips from '../common/Tips'

interface Props {
  displayCount?: number
  sales: number
  other_costs: {
    name: string
    cost: string
  }[]
  member_cost: number
  changeCallback: (type: string, params: {budget?: number, other_costs?: { name: string, cost: number}[]}) => void
  editable: boolean
}

const DetailScheduleInputArea: FC<Props> = (props) => {
  const {
    displayCount,
    sales,
    other_costs,
    member_cost,
    changeCallback,
    editable,
  } = props

  const [isDisplaySales, setIsDisplaySales] = useState<boolean>(false)
  const [isDisplayCosts, setIsDisplayCosts] = useState<boolean>(false)

  const [inputSales, setInputSales] = useState<string>("")
  const [inputOtherCosts, setInputOtherCosts] = useState<{ name: string, cost: string }[]>([])

  const salesRef = useRef<HTMLInputElement>(null)

  const [isFirst, setIsFirst] = useState<boolean>(true)

  const addOtherCost = () => {
    setInputOtherCosts([...inputOtherCosts, { name: "", cost: "" }])
  }

  const delOtherCost = (num: number) => {
    setInputOtherCosts([...inputOtherCosts.filter((_v, i) => i !== num)])
  }

  const changeOtherCostName = (num: number, name: string) => {
    setInputOtherCosts([...inputOtherCosts.map((v, i) => (i === num ? { name: name, cost: v.cost } : v))])
  }

  const changeOtherCostValue = (num: number, cost: string) => {
    setInputOtherCosts([...inputOtherCosts.map((v, i) => (i === num ? { name: v.name, cost: cost } : v))])
  }

  const formatOtherCostValue = (num: number) => {
    const tmpVal = inputOtherCosts[num].cost.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)).replace(/[^0-9]/g, '')
    setInputOtherCosts([...inputOtherCosts.map((v, i) => (i === num ? { name: v.name, cost: Number(tmpVal).toString() } : v))])
  }

  const formatSalesValue = () => {
    const tmpVal = inputSales.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)).replace(/[^0-9]/g, '')
    setInputSales(tmpVal ? Number(tmpVal).toString() : "")
    setIsDisplaySales(false)
    changeCallback(
      "budget",
      {
        budget: Number(tmpVal),
      },
    )
  }

  useEffect(() => {
    if (!isDisplaySales) return
    salesRef.current?.focus()
  }, [isDisplaySales])

  useEffect(() => {
    if (isDisplayCosts || isFirst) return
    const tmp = inputOtherCosts.filter((v) => v.name.length).map((v) => ({ name: v.name, cost: Number(v.cost) }))
    const group = tmp.reduce((s: {name: string, cost: number}[], c) => {
      const ele = s.find((p) => p.name === c.name)
      if (ele) {
        ele.cost += c.cost
      } else {
        s.push(c)
      }
      return s
    }, [])
    changeCallback(
      "other_costs",
      {
        other_costs: group,
      },
    )
    setInputOtherCosts(group.map((v) => ({ name: v.name, cost: v.cost.toString() || "0" })))
  }, [isDisplayCosts])

  useEffect(() => {
    setInputOtherCosts([...other_costs])
    setInputSales(sales ? sales.toString() : "")
    setIsFirst(false)
  }, [])

  return (
    <>
      <div
        style={{
          width: displayCount ? `calc((100% / ${displayCount}) - 8px)` : "100%",
          padding: "8px",
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          fontSize: "14px",
          maxWidth: displayCount ? "160px" : "none",
          position: "relative",
          minWidth: "140px",
        }}
      >
        {
          editable ? (
            <>
              {
                isDisplaySales ? (
                  <input
                    type="text"
                    ref={salesRef}
                    style={{ width: "100%", textAlign: "right" }}
                    onChange={(e) => setInputSales(e.target.value)}
                    onBlur={() => formatSalesValue()}
                    onKeyPress={(e) => e.key === "Enter" && formatSalesValue()}
                    value={inputSales}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      border: "solid 1px #4572ba",
                      padding: "6px 8px",
                      textAlign: "right",
                      borderRadius: "4px",
                      color: "#4572ba",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      backgroundColor: "#FFFFFF",
                    }}
                    onClick={() => setIsDisplaySales(true)}
                    role="none"
                  >
                    <FontAwesomeIcon
                      icon={['fas', 'pen']}
                    />
                    {`¥${Number(inputSales).toLocaleString()}`}
                  </div>
                )
              }
              <div
                style={{
                  width: "100%",
                  border: "solid 1px #4572ba",
                  padding: "6px 8px",
                  textAlign: "right",
                  borderRadius: "4px",
                  color: "#4572ba",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  backgroundColor: "#ececec",
                }}
                onClick={() => setIsDisplayCosts(true)}
                role="none"
              >
                <FontAwesomeIcon
                  icon={['fas', 'pen']}
                />
                {
                  inputOtherCosts.filter((v) => isNaN(Number(v.cost))).length ? (
                    <>
                      計算中…
                    </>
                  ) : (
                    <>
                      {`¥${inputOtherCosts.reduce((s, v) => s + Number(v.cost), 0).toLocaleString()}`}
                    </>
                  )
                }
              </div>
              {
                isDisplayCosts && (
                  <>
                    <div
                      style={{
                        position: "absolute",
                        top: "80px",
                        right: "0",
                        width: "430px",
                        backgroundColor: "#FFFFFF",
                        border: "solid 1px #CCCCCC",
                        borderRadius: "4px",
                        padding: "16px",
                        zIndex: "2005",
                      }}
                    >
                      <div
                        style={{
                          padding: "4px",
                          marginBottom: "8px",
                          borderBottom: "solid 1px #4572BA",
                          fontWeight: "bold",
                          color: "#4572ba",
                        }}
                      >
                        その他のコスト
                      </div>
                      {
                        inputOtherCosts.map((otherCost, i) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              marginBottom: "8px",
                              gap: "8px",
                            }}
                            key={`other_${i.toString()}`}
                          >
                            <input
                              type="text"
                              value={otherCost.name}
                              placeholder="外注費・材料費などコスト名を入力"
                              onChange={(e) => changeOtherCostName(i, e.target.value)}
                              style={{
                                width: "240px",
                              }}
                            />
                            <input
                              type="text"
                              value={otherCost.cost || ""}
                              placeholder="金額を入力"
                              onChange={(e) => changeOtherCostValue(i, e.target.value)}
                              onBlur={() => formatOtherCostValue(i)}
                              onKeyPress={(e) => e.key === "Enter" && formatOtherCostValue(i)}
                            />
                            <button
                              style={{
                                color: "#FF0000",
                                fontSize: "16px",
                              }}
                              type="button"
                              onClick={() => delOtherCost(i)}
                            >
                              <FontAwesomeIcon icon={['fas', 'trash-alt']} />
                            </button>
                          </div>
                        ))
                      }
                      {
                        !inputOtherCosts.length && (
                          <div
                            style={{
                              textAlign: "center",
                              margin: "16px",
                              color: "#999999",
                              fontSize: "16px",
                            }}
                          >
                            その他のコストはありません
                          </div>
                        )
                      }
                      <button
                        type="button"
                        onClick={() => addOtherCost()}
                        style={{
                          display: "inline-block",
                          textAlign: "center",
                          width: "100%",
                          backgroundColor: "#d6e8d4",
                          border: "1px solid #81b365",
                          color: "#81b365",
                          padding: "8px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        <FontAwesomeIcon icon={['fas', 'plus']} />
                        &nbsp;
                        その他のコスト追加
                      </button>
                    </div>
                    <div className={`close_screen gray ${isDisplayCosts || 'none'}`} role="presentation" onClick={() => setIsDisplayCosts(false)} />
                  </>
                )
              }
            </>
          ) : (
            <>
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#ffffff",
                  padding: "6px 8px",
                  textAlign: "right",
                  color: "#4572ba",
                  fontWeight: "bold",
                  borderBottom: "solid 1px #4572ba",
                }}
              >
                {`¥${sales.toLocaleString()}`}
              </div>
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#ececec",
                  padding: "6px 8px",
                  textAlign: "right",
                  color: "#4572ba",
                  fontWeight: "bold",
                  borderBottom: "solid 1px #4572ba",
                }}
              >
                {`¥${other_costs.reduce((s, v) => s + Number(v.cost), 0).toLocaleString()}`}
              </div>
            </>
          )
        }
        <div
          style={{
            width: "100%",
            backgroundColor: "#e4ffe4",
            padding: "6px 8px",
            textAlign: "right",
            color: "#4572ba",
            fontWeight: "bold",
            borderBottom: "solid 1px #4572ba",
          }}
        >
          {`¥${member_cost.toLocaleString()}`}
        </div>
      </div>
    </>
  )
}
DetailScheduleInputArea.defaultProps = {
  displayCount: undefined,
}

export default DetailScheduleInputArea
